import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aspectRatio", "children", "data", "padding"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import styled from 'styled-components';
import Image from '../../Image';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledMedia = styled.div.withConfig({
  displayName: "Media__StyledMedia",
  componentId: "sc-1oeg4wl-0"
})(["width:100%;margin-bottom:var(--dentsu-spacing-16);position:relative;height:0;padding-bottom:56.25%;.", "-card--action &,.", "-card--connection &{width:calc(100% + 3rem);margin:-1.5rem -1.5rem 1.5rem -1.5rem;}.", "-card--media &{margin-bottom:0;}&.", "-card__media--1-1{padding-bottom:100%;}&.", "-card__media--4-3{padding-bottom:75%;}&.", "-card__media--16-9{padding-bottom:56.25%;}"], prefix, prefix, prefix, prefix, prefix, prefix);
var StyledImageWrapper = styled.div.withConfig({
  displayName: "Media__StyledImageWrapper",
  componentId: "sc-1oeg4wl-1"
})(["position:absolute;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:", ";img{width:100%;height:100%;object-fit:contain;}"], function (props) {
  return props.padding;
});
var Media = forwardRef(function (_ref, ref) {
  var _dataFromProps$paddin, _cx;

  var _ref$aspectRatio = _ref.aspectRatio,
      aspectRatioFromProp = _ref$aspectRatio === void 0 ? '16-9' : _ref$aspectRatio,
      children = _ref.children,
      dataFromProps = _ref.data,
      _ref$padding = _ref.padding,
      paddingFromProp = _ref$padding === void 0 ? 0 : _ref$padding,
      rest = _objectWithoutProperties(_ref, _excluded);

  var aspectRatio;

  switch ((dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.aspectRatio) || aspectRatioFromProp) {
    case '1:1':
      aspectRatio = '1-1';
      break;

    case '16:9':
      aspectRatio = '16-9';
      break;

    case '4:3':
      aspectRatio = '4-3';
      break;

    default:
      aspectRatio = '16-9';
  }

  var padding = (_dataFromProps$paddin = dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.padding) !== null && _dataFromProps$paddin !== void 0 ? _dataFromProps$paddin : paddingFromProp;

  if (typeof padding === 'number') {
    padding = "".concat(padding, "px");
  }

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-card__media"), true), _defineProperty(_cx, "".concat(prefix, "-card__media--").concat(aspectRatio), aspectRatio), _cx));
  return _jsx(StyledMedia, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: _jsx(StyledImageWrapper, {
      padding: padding,
      children: dataFromProps ? _jsx(Image, {
        src: dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.src,
        fallbackSrc: dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.fallbackSrc,
        alt: dataFromProps === null || dataFromProps === void 0 ? void 0 : dataFromProps.name
      }) : children
    })
  }));
});
export default Media;